import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import siteMessage from "@insite/client-framework/SiteMessage";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Icon, { IconWrapper } from "@insite/mobius/Icon";
import Typography from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import Info from "@tsesco/Icons/Info";
import * as React from "react";
import { css } from "styled-components";

type Props = WidgetProps & HasProduct;

export interface ProductDetailsAddToCartButtonStyles {
    disclaimerWrapper?: InjectableCss;
}

export const addToCartButtonStyles: ProductDetailsAddToCartButtonStyles = {
    disclaimerWrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            width: 100%;
            background: #ffcd0133;
            border: #ffa500 1px solid;
            padding: 5px 5px;
            font-size: 13px;
            margin: 15px 0 10px 0;
            > span[class^="TypographyStyle"] {
                display: flex;
                // align-items: center;
                &:first-child {
                    padding-bottom: 5px;
                }
            }
            ${IconWrapper} {
                height: 15px;
                width: 15px;
                margin: 2px 5px 0 0;
                > svg {
                    height: 15px;
                    width: 15px;
                    color: #ffa500;
                    stroke-width: 3px;
                }
            }
        `,
    },
};

const styles = addToCartButtonStyles;

const ClearanceDisclaimer = ({ product }: Props) => {
    const isClearance = product?.properties?.isClearance?.toLowerCase() === "true";
    if (!isClearance) {
        return null;
    }

    return (
        <StyledWrapper {...styles.disclaimerWrapper}>
            <Typography>
                <Icon src={Info} />
                <Typography>{siteMessage("Clearance_stockMessage")}</Typography>
            </Typography>
            <Typography>
                <Icon src={Info} />
                <Typography>{siteMessage("Clearance_stockMessageNonReturnable")}</Typography>
            </Typography>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(ClearanceDisclaimer),
    definition: {
        displayName: "Clearnce Disclaimer",
        group: "Product Details",
    },
};

export default widgetModule;
